"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

const nav = [
  { href: "/canon", label: "Canon" },
  { href: "/about", label: "About" },
  { href: "/contact", label: "Contact" },
];

function isActive(pathname: string, href: string) {
  if (href === "/") return pathname === "/";
  return pathname === href || pathname.startsWith(href + "/");
}

export function SiteHeader() {
  const pathname = usePathname();

  return (
    <header className="relative border-b border-blue-900/20 bg-gradient-to-b from-[#0B1F3B] to-[#07162B] text-white">
      {/* Subtle background texture (pure CSS, no images) */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 opacity-30"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 10%, rgba(37,99,235,0.35), transparent 45%), radial-gradient(circle at 80% 0%, rgba(20,184,166,0.20), transparent 40%), linear-gradient(to right, rgba(255,255,255,0.06) 1px, transparent 1px), linear-gradient(to bottom, rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "auto, auto, 44px 44px, 44px 44px",
          backgroundPosition: "center, center, center, center",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          {/* Optional micro-mark (add later): /public/brand/fa-mark.svg */}
          {/* <img src="/brand/fa-mark.svg" alt="" className="h-7 w-7 opacity-90" /> */}

          <div className="flex flex-col leading-tight">
            <Link
              href="/"
              className="text-xs font-semibold tracking-[0.18em] uppercase text-white/95 hover:text-white"
            >
              Foundation Architect Institute
            </Link>
            <span className="mt-1 inline-flex w-fit items-center rounded-full border border-white/15 bg-white/10 px-2 py-0.5 text-[10px] font-semibold tracking-[0.18em] uppercase text-white/85">
              Formation Architecture
            </span>
          </div>
        </div>

        <nav className="flex items-center gap-6">
          {nav.map((item) => {
            const active = isActive(pathname, item.href);
            return (
              <Link
                key={item.href}
                href={item.href}
                className={[
                  "text-xs font-semibold transition-colors",
                  active
                    ? "text-white"
                    : "text-white/70 hover:text-white",
                ].join(" ")}
                aria-current={active ? "page" : undefined}
              >
                {item.label}
              </Link>
            );
          })}

          <Link
            href="/canon"
            className="inline-flex items-center justify-center rounded-md border border-white/20 bg-white/10 px-3 py-2 text-xs font-semibold text-white hover:bg-white/15 transition-colors"
          >
            Read the Canon
          </Link>
        </nav>
      </div>

      {/* Accent rule */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-blue-400/60 to-transparent" />
    </header>
  );
}